export { SkeletonRectangle } from './SkeletonRectangle';

export * from './SkeletonRectangle.types';
